var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","hide-on-single-page":_vm.current<=12,"total":_vm.current,"current-page":_vm.page,"page-size":_vm.limit,"layout":"prev, pager, next","pager-count":_vm.pagerCount},on:{"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }